export default __webpack_public_path__ + "img/section-header-background-blue-d0c35710.png";